export default "__VITE_ASSET__1iN9AYiV__"